// Map the icon names used in _docs/design/icons.jsx to lucide-react.
// The original mock uses inline SVGs; lucide-react gives us the same shapes
// with a clean React API.
import type { LucideIcon } from "lucide-react";
import {
  ArrowLeft,
  ArrowRight,
  Bell,
  Check,
  ChevronDown,
  ChevronUp,
  CircleCheck,
  Clock,
  Download,
  Edit,
  FileText,
  Folder,
  History,
  Info,
  Leaf,
  Mail,
  MessageSquare,
  RefreshCw,
  TriangleAlert,
  Upload,
  UploadCloud,
  X,
} from "lucide-react";

const MAP: Record<string, LucideIcon> = {
  check: Check,
  checkCircle: CircleCheck,
  alertTri: TriangleAlert,
  info: Info,
  upload: Upload,
  cloudUp: UploadCloud,
  refresh: RefreshCw,
  document: FileText,
  file: FileText,
  folder: Folder,
  history: History,
  bell: Bell,
  chevDown: ChevronDown,
  chevUp: ChevronUp,
  arrowRight: ArrowRight,
  back: ArrowLeft,
  edit: Edit,
  email: Mail,
  download: Download,
  chat: MessageSquare,
  x: X,
  leaf: Leaf,
  clock: Clock,
};

export function Icon({
  name,
  size = 16,
  color,
  className,
}: {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}) {
  const C = MAP[name] ?? Info;
  return <C size={size} color={color} className={className} />;
}
